/** @format */

const OOTBR_CONSTANTS = {
  BOT_ADMIN_PRIVILEGES: [
    1804, 1805, 1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813, 1814, 1815, 1816, 1817, 1818, 1819, 1820, 1821, 1822,
    1823, 1824, 1825, 1826, 1827, 1828, 1829, 1830, 1831, 1832, 1833, 1834, 1835, 1836, 1837, 1838, 1839, 1840, 1841,
    1842, 1843, 1844, 1845, 1846,
  ],

  LPA_PERMISSION_GROUP: 'lpa',
  ADMIN_PERMISSION_GROUP: 'admin',
  AC_FEATURE_GENERATIVE_AI_ACCESS: 'AIAutomation.GenerativeAI',
  AC_FEATURE_GENERATIVE_AI_ACCESS_PREVIEW: 'AIAutomation.GenerativeAI_Preview',
  AC_FEATURE_REPORT_CENTER_ACCESS: 'Reporting.ReportCenter',
  AC_FEATURE_DATA_TRANSPORTER_ACCESS: 'Intelligence.dataTransporterAccess',

  OOTB_SERVICE_NAME: 'ootb',
  ACCOUNT_CONFIG_SERVICE_NAME: 'accountConfigReadWrite',
  MESSAGING_HISTORY_SERVICE_NAME: 'msgHist',
  DATA_TRANSPORTER_SERVICE_NAME: 'transporter',
  AGENT_MANAGER_WORKSPACE_SERVICE_NAME: 'agentManagerWorkspace',
  SELF_SERVICE_TRIAL: 'intelligence.generativeInsights.selfServiceTrial',

  VIEW_AGENT_CONVERSATIONS_PACKAGE: [1798, 10],
  VIEW_CONVERSATION_HISTORY_PACKAGE: [1575],
  VIEW_AGENT_LISTS_PACKAGE: [1574],
  DATA_TRANSPORTER_INTEGRATION_PACKAGE: [1869, 1871, 1874],
  SHARE_DASHBOARD_PACKAGE: [1910],

  CONVERSATIONS_MODEL_ID: 1710,
  ENGAGEMENT_CONTROLLER_MODEL_ID: 120,

  ANONYMOUS_USER_ID: 'Anonymous',

  ZINDEX_NEW_CCUI: 2000,

  SEARCH_BY_KEYWORD: {
    FETCH_LIMIT: 100,
    MAX_RECORDS: 1000,
  },
};

export const USER_PERMISSION_PACKAGES = [
  OOTBR_CONSTANTS.VIEW_AGENT_CONVERSATIONS_PACKAGE,
  OOTBR_CONSTANTS.VIEW_CONVERSATION_HISTORY_PACKAGE,
];

export const DATA_SOURCE_MODEL_ID_TO_NAME = {
  1710: 'Conversation',
  120: 'Engagement Controller',
};

export default OOTBR_CONSTANTS;
